import { MobileUserConstants, dealerConstants } from "../constants";

export function MobileUser(state = {}, action) {
  switch (action.type) {
    case MobileUserConstants.LOADING_REQUEST:
      return {
        ...state,
        loding: action.isbool,
      };

    //start City
    case dealerConstants.GETCITYDDL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case dealerConstants.GETCITYDDL_SUCCESS:
      return {
        ...state,
        cityddl: action.datas,
      };
    case dealerConstants.GETCITYDDL_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    //end City
    case MobileUserConstants.DIALOG_REQUEST:
      return {
        ...state,
        showDialog: action.isbool,
      };
    case MobileUserConstants.DIALOG_ISACTIVE_REQUEST:
      return {
        ...state,
        showIsActiveDialog: action.isbool,
      };
    case MobileUserConstants.GETALL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case MobileUserConstants.GETALL_SUCCESS:
      return {
        ...state,
        items: action.datas,
      };
    case MobileUserConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case MobileUserConstants.CREATE_REQUEST:
      return {
        ...state,
        creating: true,
      };
    case MobileUserConstants.CREATE_SUCCESS:
      return {
        ...state,
        items:
          state.items == null ? [action.data] : [action.data, ...state.items],
      };
    case MobileUserConstants.CREATE_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case MobileUserConstants.UPDATE_REQUEST:
      return {
        ...state,
        items: state.items.map((item) =>
          item.UserId == action.data.UserId ? { ...item, updating: true } : item
        ),
      };
    case MobileUserConstants.UPDATE_SUCCESS:
      return {
        ...state,
        items: state.items.map((item) =>
          item.UserId === action.data.UserId ? action.data : item
        ),
      };
    case MobileUserConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case MobileUserConstants.DELETE_REQUEST:
      return {
        ...state,
        deleting: true,
      };
      
    case MobileUserConstants.DELETE_SUCCESS:
      return {
        ...state,
        items: state.items.map((item) =>
          item.UserId === action.data
            ? {
                UserId: item.userId,
                UserName: item.UserName,
                Email: item.Email,
                MobileNo: item.MobileNo,
                CompanyId: item.CompanyId,
                CompanyName: item.CompanyName,
                RoleId: item.RoleId,
                RoleName: item.RoleName,
                IsActive: item.isActive,
                Password: item.Password,
                ConfirmPassword: item.Password,
                CreatedDate: item.CreatedDate,
              }
            : item
        ),
      };             
    case MobileUserConstants.GETROLEDDL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case MobileUserConstants.GETROLEDDL_SUCCESS:
      return {
        ...state,
        rollddl: action.datas,
      };
    case MobileUserConstants.GETROLEDDL_FAILURE:
      return {
        ...state,
        error: action.error,
      };
      case MobileUserConstants.GETWDDL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case MobileUserConstants.GETWDDL_SUCCESS:
      return {
        ...state,
        Wdd2: action.datas,
      };
    case MobileUserConstants.GETWDDL_FAILURE:
      return {
        ...state,
        error: action.error,
      };

      case MobileUserConstants.GETSDDL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case MobileUserConstants.GETSDDL_SUCCESS:
      return {
        ...state,
        UserSData: action.datas,
      };
    case MobileUserConstants.GETSDDL_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    case MobileUserConstants.DELETE_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case MobileUserConstants.ISACTIVE_REQUEST:
      return {
        ...state,
        activating: true,
      };
    case MobileUserConstants.ISACTIVE_SUCCESS:
      return {
        ...state,
        items: state.items.map((item) =>
          
          item.UserId === action.data.UserId
            ? {
                UserId: item.UserId,
                UserName: item.UserName,
                Email: item.Email,
                MobileNo: item.MobileNo,
                CompanyId: item.CompanyId,
                CompanyName: item.CompanyName,
                RoleId: item.RoleId,
                RoleName: item.RoleName,
                IsActive: action.data.IsActive,
                TotalRows: item.TotalRows,
                Password: item.Password,
                ConfirmPassword: item.Password,
                CreatedDate: item.CreatedDate,
              }
            : item
        ),
      };
    case MobileUserConstants.ISACTIVE_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case MobileUserConstants.GETEXPORT_REQUEST:
      return {
        ...state,
        exporting: true,
      };
    case MobileUserConstants.GETEXPORT_SUCCESS:
      return {
        ...state,
        exportitems: action.datas,
      };
    case MobileUserConstants.GETEXPORT_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
}
